import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared.module';

import { FormFieldsSelectRowDirective } from './form-fields-select-row.directive';

@NgModule({
    imports: [SharedModule],
    declarations: [FormFieldsSelectRowDirective],
    exports: [FormFieldsSelectRowDirective]
})
export class FormFieldsSelectRowModule { }
